import * as React from 'react';

const SvgCookbook: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={3} y={5.5} width={4} height={2} rx={1} fill="currentColor" />
      <rect x={3} y={11} width={4} height={2} rx={1} fill="currentColor" />
      <rect x={3} y={16.5} width={4} height={2} rx={1} fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4a1 1 0 011-1h8v5.5l1.5-1.214L17 8.5V3h2a1 1 0 011 1v16a1 1 0 01-1 1H6a1 1 0 01-1-1v-.5h1a2 2 0 100-4H5V14h1a2 2 0 000-4H5V8.5h1a2 2 0 100-4H5V4zm0 14.5v-2h1a1 1 0 110 2H5zM6 13H5v-2h1a1 1 0 110 2zM5 7.5v-2h1a1 1 0 110 2H5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgCookbook;
